import { apiRequest } from "./api";
import { getStripe } from "./stripe";
import { firebaseApp } from "./firebase";
import { getStripePriceId } from "./prices"; // your existing price helper

// --------------------- Stripe Helpers ---------------------

export async function redirectToCheckout(planId) {
  const stripe = await getStripe();

  const session = await apiRequest("stripe-create-checkout-session", "POST", {
    priceId: getStripePriceId(planId),
    planName: planId,
    successUrl: `${window.location.origin}/dashboard?paid=true`,
    cancelUrl: `${window.location.origin}/dashboard`,
  });

  window.history.replaceState({}, "", "/dashboard");

  return stripe.redirectToCheckout({ sessionId: session.id });
}

export async function redirectToBilling() {
  const stripe = await getStripe();

  const session = await apiRequest("stripe-create-billing-session", "POST", {
    returnUrl: `${window.location.origin}/dashboard`,
  });

  window.history.replaceState({}, "", "/dashboard");
  window.location.href = session.url;
}

export async function cancelSubscription() {
  return apiRequest("stripe-cancel-subscription", "POST");
}

// --------------------- Firebase Helpers ---------------------

// Example Firebase helper
export async function getUserDocument(uid) {
  const firestore = (await import("firebase/firestore")).getFirestore(firebaseApp);
  const doc = (await import("firebase/firestore")).doc;
  const getDoc = (await import("firebase/firestore")).getDoc;

  const userDoc = doc(firestore, "users", uid);
  const snapshot = await getDoc(userDoc);
  return snapshot.exists() ? snapshot.data() : null;
}

// Firebase delete account!
export async function deleteAccount() {
  return apiRequest("firebase-delete-account", "POST");
}

// Check if a production already exists (server-side validation)
export async function checkIfProductionNameAndCrewOrExtraKeyExists(productionName, accessKey, accessKeyForExtras, excludeOwnProductionId) {
  return apiRequest("firebase-check-production-duplicates", "POST", {
    productionName,
    accessKey,
    accessKeyForExtras,
    excludeOwnProductionId
  });
}

// Save a pending signup (server-side)
export async function savePendingSignup(uid, productionData) {
  return apiRequest("firebase-save-pending-signup", "POST", {
    uid,
    productionData,
  });
}

// Get a pending signup (server-side)
export async function getPendingSignup(uid) {
  return apiRequest("firebase-get-pending-signup", "POST", {
    uid,
  });
}

// Delete a pending signup (server-side)
export async function deletePendingSignup(uid) {
  return apiRequest("firebase-delete-pending-signup", "DELETE", {
    uid,
  });
}

// Get trial usage info by email (server-side)
export async function getTrialUsage(email) {
  return apiRequest("firebase-get-trial-usage", "POST", {
    email,
  });
}

// Create production (server-side)
export async function createProduction(uid, productionData) {
  return apiRequest("firebase-create-production", "POST", {
    uid,
    productionData
  });
}

// Validate and invalidate production keys (server-side)
export async function validateProductionKeys(productionId, oldProductionData, newProductionData) {
  return apiRequest("firebase-check-production-key-change", "POST", {
    productionId,
    oldProductionData,
    newProductionData,
  });
}